module.exports = __webpack_public_path__ + "img/receipt.a35dc213.svg";